import Header from "../../components/Header/Header";
import iconTelWhite from "../../assets/icon_tel_wh.svg";
import { Accordion, AccordionItem } from "@szhsin/react-accordion";
import useReactGASend from "../../hooks/useReactGASend";
import { GiCheckMark } from "react-icons/gi";
import React from "react";


const common = [
  {
    title: "입장시간/게이트",
    content: "[ICON:check]홈경기 입장시간 \nㆍ주중 : 경기 1시간 30분 전 \nㆍ주말 : 경기 2시간 전 \n\n ※  푸리 이상 멤버십 회원은 전용 게이트를 통해 1시간 선입장 가능합니다. \n\n [ICON:check]입장 게이트 \nㆍ일반 고객 \n - 1루 방면 : 1번, 3번 게이트  \n - 3루 방면 : 5번, 6번 게이트   \n - 외야 방면 : 7번 게이트 \n\n ㆍ멤버십 전용 게이트 \n  - 랜디 게이트 \n[SPACE]: 등급 회원 전용 \n - 스타벅스 게이트  \n[SPACE]: 푸리 이상 회원 전용 \n\n※  멤버십 선입장은 전용 게이트를 통해서만 이용 가능합니다. \n※  멤버십 회원이 예매한 티켓에 한 해 동반인 선입장 가능합니다." ,
    reference: "",
  },
  {
    title: "반입규정(음식물)",
    content:
      "경기장 내 물품 반입 규정은 KBO SAFE 캠페인을 바탕으로 운영되며, KBO 리그 전 구장에 공통 적용됩니다. \n\n 주요 반입 규정에 대해 안내드리며, 세부 사항은 하단 링크를 통해 KBO 홈페이지에서 확인 가능합니다. \n\n [ICON:check]반입 가능 품목 \n- 가방 1개(45*45*20cm 이하) \n- 쇼핑백 1개(30*50*12cm 이하) \n- 미개봉 총량 1L 이하의 음료(1L PET 1개 또는 캔 2개) \n\n[ICON:check]반입 불가 품목 \n- 유리병 및 1L 초과 PET/알루미늄 캔 용기에 담긴 음료 \n- 8도 이상의 주류 \n[SPACE]*막걸리 등 향이 강한 종류는 제한될 수 있습니다. \n- 과일 등(미리 잘라온 경우 반입 가능) \n- 가스버너 등 취사도구 \n- 아이스박스, 드라이아이스, 얼음 등 \n- 과도한 양이나 관람에 방해, 또는 쾌적한 구장 환경 관리에 저해가 되는 종류(국물류 및 냄새가 심한 음식물 등) \n\n ※ 영유아 및 노약자, 장애인 등에 필요한 품목으로 확인된 경우에 한 해 제재하지 않습니다.(필요량의 분유/이유식 등) \n※ 선수 및 관람객의 안전이나 관람 환경에 지장을 초래할 것으로 판단되는 물품은 각 구단 및 안전요원의 제재가 있을 수 있습니다.",
    reference: "",
    buttons: [
      { 
        title: "KBO SAFE 캠페인 확인하기",
        link: "https://www.koreabaseball.com/Kbo/BusinessAndEvent/SafeGuide.aspx"
      }
    ]
  },
  {
    title: "반입규정(기타 물품)",
    content:
      "경기장 내 물품 반입 규정은 KBO SAFE 캠페인을 바탕으로 운영되며, KBO 리그 전 구장에 공통 적용됩니다. \n\n 주요 반입 규정에 대해 안내드리며, 세부 사항은 하단 링크를 통해 KBO 홈페이지에서 확인 가능합니다. \n\n [ICON:check]반입 가능 품목 \n - 가방 1개(45*45*20cm 이하) \n - 쇼핑백 1개(30*50*12cm 이하) \n\n [ICON:check]반입 불가 품목 \n- 무기류, 화기류, 화약류, 인화성 물질 \n- 파편이 생길 수 있거나 매우 단단한 물질 \n- 칼, 가위 등 타인에게 위해를 가할 수 있는 도구 \n- 깃발, 막대, 삼각대 등 타격용으로 사용될 위험이 있는 것으로 판단되는 도구(재질 무관) \n- 소음이 심한 응원 도구(앰프, 대북, 꽹과리 등) \n- 구단과 합의되지 않은 현수막 등 모든 표현물 \n- 상업적 행위를 위한 물품 \n- 반려동물 동반 불가 \n- 관람에 방해를 줄 수 있다고 구단이 판단한 물품 \n- 돗자리, 휴대용 의자, 간이테이블 등 관람 및 통행에 방해를 주는 물품 (몰리스 그린존 예외 적용) \n\n ※ 선수 및 관람객의 안전이나 관람 환경에 지장을 초래할 것으로 판단되는 물품은 각 구단 및 안전요원의 제재가 있을 수 있습니다.",
    reference:
      "",
      buttons: [
        { 
          title: "KBO SAFE 캠페인 확인하기",
          link: "https://www.koreabaseball.com/Kbo/BusinessAndEvent/SafeGuide.aspx"
        }
      ]
  },
  {
    title: "반입규정(유모차, 캐리어)",
    content:
      "유모차, 웨건, 캐리어는 일부 좌석에 한 해 반입이 가능합니다. \n\n [ICON:check]휴대 가능 좌석 \n - 스카이박스, 미니 스카이박스, 몰리스 그린존, 내야패밀리존,   외야패밀리존, 로케트배터리외야파티덱 \n\n ※ 타 관람객 동선 방해, 또는 비상통로 보관 시 현장 스태프의 이동 요청이 있을 수 있습니다. \n\n ※ 가능 좌석 외 좌석 이용 시 SELF 보관소 이용 \n[SPACE] - SELF 보관소 위치 : GATE 3 내부, 스타벅스 게이트 내부, GATE 6 내부, GATE 7 내부",
    reference: "",
  },
  {
    title: "홈구장 안내",
    content:
      "아래 링크를 통해 홈구장 정보를 확인할 수  있습니다. \n\n - 좌석 배치도 \n- 매점 정보, 위치 \n- 화장실 위치 \n- GATE 위치 \n\n ※ SSG랜더스 APP으로 이동됩니다.   \n[SPACE](SSG랜더스 APP 설치필요)",
    reference: "",
    buttons: [
      { 
        title: "홈구장 안내 바로가기",
        link: "https://www.ssglanders.com/deepLink/stadium"
      }
    ]
  },
  {
    title: "찾아오시는 길",
    content:
      "[찾아오는 길] \n\n [ICON:check]주소 : 인천 미추홀구 매소홀로 618  인천 SSG랜더스필드 \n\n [ICON:check]시내버스 이용 시 \n- 부평역 111-2번 → 문학경기장 하차 \n- 주안역 63, 522번 → 문학경기장(박태환수영장) 하차 \n- 동막역 6, 303, 304번 → 문학경기장(박태환수영장) 하차 \n- 제물포역 4, 63번 → 문학경기장 하차 \n- 인하대역 5, 27, 111-2번 → 문학경기장 하차 \n- 석천사거리역 11번 → 문학경기장 하차 \n- 인천논현역 27번 → 문학경기장 하차 \n\n [ICON:check]정류장 안내 \n- 문학경기장 [북문쪽] : 4, 5, 11, 27, 46, 82, 111-2, 515번 \n- 문학경기장(박태환수영장) [동문쪽] : 63, 754, 780-2, 522, 523, 303번 \n\n[ICON:check]고속버스 이용 시 \n- 인천종합터미널 → 인천터미널역에서 인천지하철 환승 →   문학경기장역 하차 \n- 인천종합터미널 → 도보 → 문학경기장 \n\n [ICON:check]고속도로 이용 시 \n- 경인고속도로 : 도화 IC → 동양장사거리 → 문학경기장 \n- 제2경인고속도로 : 서창 IC → 남동 IC → 문학 IC → 문학경기장 \n- 서해안고속도로 : 서창 IC → 남동 IC → 문학 IC → 문학경기장 \n- 서울외곽순환고속도로 : 장수 IC → 수원방향 → 서창 IC → 남동 IC → 문학 IC → 문학경기장",
    reference: ""
  }
];


const ICON_MAP = {
  check: <GiCheckMark className="inline-block mr-1"/>
}

const formatText = (text) => {
  return text.split("\n").map((line, index) => {
    const elements = [];

    let rest = line;

    // 1. 앞에 [SPACE]가 몇 개 있는지 계산
    const spaceMatches = rest.match(/^(\[SPACE])+/);
    if (spaceMatches) {
      const count = spaceMatches[0].match(/\[SPACE\]/g).length;
      for (let i = 0; i < count; i++) {
        elements.push(<span key={`space-${i}`} className="pl-2" />);
      }
      rest = rest.replace(/^(\[SPACE\])+/,"").trim();
    }

    // 2. 아이콘 처리
    const iconMatch = rest.match(/\[ICON:(.+?)\]/);
    if (iconMatch) {
      const iconKey = iconMatch[1];
      elements.push(
        <span key="icon" className="inline-flex items-baseline pt-1">
          {ICON_MAP[iconKey]}
        </span>
      );
      rest = rest.replace(iconMatch[0], "").trim();
    }

    // 3. 텍스트
    elements.push(<span key="text">{rest}</span>);

    return (
      <div key={index} className="flex items-start">
        {elements}
        {index < text.split("\n").length - 1 && <br />}
      </div>
    );
  });
};

export const AccordionItemComponent = ({
  item,
  index,
}) => (
  <AccordionItem
    key={index}
    itemKey={index}
    className="mb-2"
    header={({state}) => 
      <div className={`flex items-center w-full pb-2 text-lg font-semibold text-gray-950 border border-[#D1D5DB] p-2.5 bg-white text-left ${state.isEnter ? 'rounded-bl-none rounded-br-none rounded-tl-[30px] rounded-tr-[30px] border-none' : 'rounded-full'}`}>
        <span
          className={`inline-flex items-center justify-center p-3 h-10 bg-black shadow-md rounded-full text-white text-2xl font-semibold shrink-0 mr-2`}
        >
          Q
        </span>
        {item.title}
      </div>
    }
  >
  {({state}) => 
    <div className={`p-6 border rounded-3xl border-[#D1D5DB] bg-white ${state.isEnter && 'rounded-tl-none rounded-tr-none border-none mt-[-10px]'}`}>
      <p className="font-medium text-gray-950">{formatText(item.content)}</p>
      {item.buttons && (
        <div className="flex justify-center flex-col">
          {item.buttons.map(button => (
            <LinkItem
              title={button.title}
              url={button.link}
              styles={"mx-6"}
            />
          ))}
        </div>
      )}
    </div>
  } 
  </AccordionItem>
);


export const LinkButton = ({
  url,
  className,
  imgSrc,
  altText,
  buttonText,
  onClick,
}) => (
  <a
    onClick={onClick}
    href={url}
    className={className}
  >
    <span className="shrink-0">
      <img src={imgSrc} alt={altText} />
    </span>
    <span className="flex-1 text-center">{buttonText}</span>
  </a>
);

export const LinkItem = ({ title, url, isPhoneLink, onClick, styles }) => (
  <li className="pt-4 list-none">
    <a
      onClick={onClick}
      href={url}
      target={isPhoneLink ? undefined : "_blank"}
      rel={isPhoneLink ? undefined : "noopener noreferrer"}
      className={`flex items-center bg-[#FFFFFF] ${
        isPhoneLink ? "gap-4" : ""
      } justify-center h-12 rounded-[16px] ${
        isPhoneLink ? "border-2" : "border"
      } border-[#FFA2A2] text-[#CE152D] font-semibold ${styles}`}
    >
      {isPhoneLink && <img alt="상담원 연결 전화 아이콘" />}
      {title}
    </a>
  </li>
);


const GamePage = () => {
  const { makeEventTrackFn } = useReactGASend();
  const trackButtonClick = (title) => {
    makeEventTrackFn({
      category: "event",
      action: title,
    });
  };

  return (
    <section className="p-hasHeader">
      <Header title="관람 안내" />
      <div className="bg-white p-7 rounded-3xl mb-6 font-medium text-base mt-2 text-gray-950">
        <div className="flex items-center"><GiCheckMark className="inline-flex items-baseline mr-1"/> 홈경기 입장시간</div>
        <div>ㆍ주중 : 경기 1시간 30분 전</div>
        <div>ㆍ주말 : 경기 2시간 전</div>
        <br/>
        <div>※  푸리 이상 멤버십 회원은 전용 게이트를 통해 1시간 선입장 가능합니다.</div>
        <br/>
        <div className="flex items-center"><GiCheckMark className="inline-flex items-baseline mr-1"/> 입장 게이트</div>
        <div>ㆍ일반 고객</div>
        <div>- 1루 방면 : 1번, 3번 게이트</div>
        <div>- 3루 방면 : 5번, 6번 게이트</div>
        <div>- 외야 방면 : 7번 게이트</div>
        <br/>
        
        <div>ㆍ멤버십 전용 게이트</div>
        <div>- 랜디 게이트</div>
        <div className="pl-2">: 랜디 회원 전용</div>
        <div>- 스타벅스 게이트</div>
        <div className="pl-2">: 푸리 이상 회원 전용</div>
        <br/>
        <div>※  멤버십 선입장은 전용 게이트를 통해서만 이용 가능합니다.</div>
        <div>※  멤버십 회원이 예매한 티켓에 한 해 동반인 선입장 가능합니다.</div>
      </div>

      <Accordion transition transitionTimeout={250}>
        {common.map((item, index) => (
          <AccordionItemComponent
            key={index}
            item={item}
            index={index}
          />
        ))}
      </Accordion>

      <div className="flex flex-col items-center mt-10 bg-white p-5 rounded-3xl justify-center w-full ">
        <div className="text-base font-medium text-[#4A5565] pb-2 flex text-center justify-center">추가적인 도움이 필요하신가요?</div>
        <LinkButton
          url="tel:032-455-2600"
          className="flex items-center justify-between w-36 h-9 bg-brand-secondary rounded-[30px] text-white px-6 py-6 text-sm font-medium mb-1.5"
          imgSrc={iconTelWhite}
          buttonText="전화상담"
          onClick={() => trackButtonClick("관람안내_전화상담")}
        />
      </div>
    </section>
  );
};

export default GamePage;
